<template>
  <div class="top-menu">
    <ul class="top-menu-list">
      <li v-for="(item, index) in menuRouter.slice(0, -2)"
          :key="index">
        <!-- && item.name!='news' -->
        <router-link v-if="item.name != 'originality'"
                     tag="a"
                     class="top-m-item"
                     :to="item">{{ item.meta.title }}
        </router-link>
        <!-- <a @click="click" v-if="item.name=='news'"
                   :class="{'active':originalityDir}"
                   class="top-m-item">{{item.meta.title}}</a> -->
        <a v-if="item.name == 'originality'"
           :class="{ 'active': originalityDir }"
           class="top-m-item">{{ item.meta.title }}</a>
        <div v-if="item.name == 'originality'"
             class="second-menu"
             :style="boxDisplay"
             @click="onshowBox">
          <div class="project-status-p">
            <div class="status-text-p">
              <span>项目状态：</span>
            </div>
            <div class="status1-p status-p">
              <span class="disc-p"></span>
              <span>施工中</span>
            </div>
            <div class="status3-p status-p">
              <span class="disc-p"></span>
              <span>竣工中</span>
            </div>
            <div class="status4-p status-p">
              <span class="disc-p"></span>
              <span>决算中</span>
            </div>
            <div class="status2-p status-p">
              <span class="disc-p"></span>
              <span>已结案</span>
            </div>
          </div>
          <div class="second-menu-inner">
            <div class="second-m-box">
              <div class="second-m-row"
                   v-for="(jxj, i) in jxjSubMenu.parents"
                   :key="i">
                <h4 class="second-label">
                  {{ jxj.parentName }}
                  <i class="second-arrow-icon"></i>
                </h4>
                <div class="second-info">
                  <a tag="a"
                     @click="jianOn(child.id)"
                     v-for="(child, c) in jxjSubMenu.projectLogs"
                     :key="c"
                     v-if="jxj.id == child.parentId"
                     class="second-item"
                     :class="getClass(child.forumStatus)">
                    <span class="disc-p"></span>
                    <span>{{ child.title }}</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="second-button">
              <!--                            新添加申请-->
              <!-- <span class="dm-btn dm-btn-default" @click="dialogVisible = true">创建订单前流程</span> -->
              <span class="dm-btn dm-btn-default"
                    style="margin-right: 10px;"
                    @click="goApply2">创建告知函</span>
              <span class="dm-btn dm-btn-default"
                    @click="goApply">申请匠心记</span>

            </div>
          </div>
        </div>
      </li>
    </ul>
    <!--        //弹出层-->
    <el-dialog id="my-dialog"
               :append-to-body="true"
               title="请选择您需要的流程"
               :visible.sync="dialogVisible"
               width="600px"
               center>
      <span slot="footer"
            class="dialog-footer">
        <el-button class="el-button-primary">填写项目信息</el-button>
        <el-button class="el-button--danger"
                   @click="goToApply">创建订单前流程</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { getJxjList } from '../../api/index.js';
import { menuRouter } from '../../router.js';
import './header-menu.css'

export default {
  name: 'headerMenu',
  data () {
    return {
      boxDisplay: '',
      jxjSubMenu: {},
      menuRouter: menuRouter,
      originalityDir: 0,
      dialogVisible: false,
    };
  },
  methods: {
    // click(){
    //     location.href="https://www.iduilv.com/spc/news"
    // },
    jianOn (id) {
      let routeData = this.$router.resolve({ name: 'jxjDetail', params: { id: id } });
      window.open(routeData.href, '_blank');
    },
    onshowBox () {
      this.boxDisplay = 'display: none'
      setTimeout(() => {
        this.boxDisplay = ''
      }, 100)
    },
    async getJxjList () {
      let res = await getJxjList();
      if (res.Type == 'Success') {
        this.jxjSubMenu = res.Data;
      }
      // this.jxjSubMenu = res;
      // console.log(res);
    },

    goToApply () {   //新添加申请
      this.dialogVisible = false;
      this.$router.push({ name: 'inForm' });
    },

    goApply () {
      this.$router.push({ name: 'jxjApply' });
    },
    goApply2 () {
      this.$router.push({ name: 'jxjCreate' });
    },
    getClass (status) {
      switch (status) {
        case 1:
          return "status1-p";
        case 2:
          return "status2-p";
        case 3:
          return "status3-p";
        case 4:
          return "status4-p";
      }
    }
  },
  created () {
    this.getJxjList();

  },
  watch: {
    $route (to, from) {
      if (location.href.indexOf('originality') > -1) {
        this.originalityDir = 1;
      } else {
        this.originalityDir = 0;
      }
    }
  }
};
</script>

<style scoped></style>
